import { Paragraph, TextRun } from "docx"

export const renderVolunteerSection = volunteerExperiences => {
  if (!volunteerExperiences || volunteerExperiences.length === 0) {
    return []
  }

  return [
    new Paragraph({
      children: [
        new TextRun({
          text: "VOLUNTEER",
          bold: true,
          size: 21,
        }),
      ],
      spacing: {
        before: 200,
      },
      border: {
        bottom: {
          color: "#d3d3d3",
          space: 1,
          style: "single",
          size: 6,
        },
      },
    }),
    ...volunteerExperiences
      .map(experience => {
        const {
          title = "TITLE",
          employer = "ORGANIZATION",
          location = "LOCATION",
          bulletPoints = [],
          startDate = "",
          endDate = "Present",
        } = experience

        return [
          new Paragraph({
            spacing: {
              before: 50,
            },
            children: [
              new TextRun({
                text: `${title}`,
                size: 21,
                bold: true,
              }),
            ],
          }),
          new Paragraph({
            children: [
              new TextRun({
                text: `${employer} | ${location} | ${startDate} - ${endDate}`,
              }),
            ],
          }),
          ...bulletPoints
            .map(
              bulletPoint =>
                new Paragraph({
                  bullet: {
                    level: 0,
                  },
                  children: [
                    new TextRun({
                      text: bulletPoint,
                      font: "cambria",
                      size: 20,
                    }),
                  ],
                })
            )
        ]
      })
      .flat(),
  ]
}
